import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Icon from "@material-ui/core/Icon";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.js";

const useStyles = makeStyles((theme) => ({
  ...modalStyle(theme),
  inputAdornmentIcon: {
    color: "#555",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function PasswordModal({ open, onConfirm, onCancel, message = "Por favor, insira a senha:" }) {
  const classes = useStyles();
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [lembrar, setLembrar] = useState(true);

  useEffect(() => {
    if (open) {
      setPassword("");
      setError(false);
    }
  }, [open]);

  const handleConfirm = () => {
    if (!password || password.trim() === "") {
      setError(true);
      return;
    }
    onConfirm(password, lembrar);
    setPassword("");
    setError(false);
  };

  const handleCancel = () => {
    setPassword("");
    setError(false);
    if (onCancel) {
      onCancel();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleConfirm();
    }
  };

  return (
    <Dialog
      classes={{
        root: classes.modalRoot,
        paper: classes.modal,
      }}
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleCancel}
      aria-labelledby="password-modal-title"
      aria-describedby="password-modal-description"
    >
      <DialogTitle id="password-modal-title" className={classes.modalTitle}>
        {message}
      </DialogTitle>
      <DialogContent className={classes.modalBody}>
        <CustomInput
          labelText="Senha"
          id="password-input"
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            type: "password",
            autoComplete: "off",
            value: password,
            onChange: (e) => {
              setPassword(e.target.value);
              setError(false);
            },
            onKeyPress: handleKeyPress,
            endAdornment: (
              <InputAdornment position="end">
                <Icon className={classes.inputAdornmentIcon}>
                  lock_outline
                </Icon>
              </InputAdornment>
            ),
          }}
          error={error}
          helperText={error ? "Por favor, insira uma senha" : ""}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={lembrar}
              onChange={(e) => setLembrar(e.target.checked)}
              color="primary"
            />
          }
          label="Lembrar senha neste computador"
        />
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        <Button
          onClick={handleCancel}
          color="transparent"
          simple
        >
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          color="primary"
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

